// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"840":"9795848e","911":"9795848e"}[chunkId] + ".chunk.css";
};